  import { Button, DatePicker, Form, Select, Space, TimePicker, notification } from "antd";
import TextArea from "antd/lib/input/TextArea";
import moment from "moment";
import { useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "shared/redux/store";
import API_SERVICE from "shared/services/api-service";
import { getEnumKey } from "shared/services/Utility";
import type { RangePickerProps } from "antd/es/date-picker";
import dayjs from "dayjs"

interface IProductFooter {
  dispositionList: any;
  setIsProductFooter: any;
  caseId: any;
  selectedStageDetail: any;
  caseStatus: any;
  getLeadById: any;
}

const ProductFooter: React.FC<IProductFooter> = (props: IProductFooter) => {
  const {
    dispositionList,
    setIsProductFooter,
    caseId,
    selectedStageDetail,
    caseStatus,
    getLeadById,
  } = props;
  const [formComment] = Form.useForm();
  const [dispositionList2, setDispositionList2] = useState([]);
  const [disposition1Selected, setDisposition1Selected]  = useState("")
  const [disposition1Date, setDisposition1Date] = useState() as any
  const [disposition1Time, setDisposition1Time] = useState() as any
  const [loading, setLoading] = useState(false);
  const {appColors}: any = useSelector((state: RootState) => state.common);
  const now = dayjs();
  const currentHour = now.hour();
  const currentMinute = now.minute();
  const isNowPM = currentHour >= 12;
  const onDisposition1Select = (key: string) => {
    const displayDispositionList2 = dispositionList?.find((item) => {
      return item?.level1 == key;
    });
    setDisposition1Selected(key)
    setDispositionList2(displayDispositionList2?.level2 ?? []);
  };

  const disabledDate: RangePickerProps["disabledDate"] = (current) => {
    if (!current) return false;
    const endOfToday = moment().endOf('day'); 
    return current.isBefore(endOfToday, 'day'); 
  };

  const disabledTime = () => {
      if (!disposition1Date) {
      return {
        disabledHours: () => Array.from({ length: 24 }, (_, i) => i),
        disabledMinutes: () => Array.from({ length: 60 }, (_, i) => i),
        disabledSeconds: () => Array.from({ length: 60 }, (_, i) => i),
      };
    }
    return {
      disabledHours: () => {
        return Array.from({ length: 24 }, (_, i) => i).filter(hour => hour < currentHour);
      },
      disabledMinutes: (selectedHour) => {
        const selectedHour24 = selectedHour % 12 + (isNowPM ? 12 : 0);
  
        if (selectedHour24 === currentHour) {
          return Array.from({ length: 60 }, (_, i) => i).filter(min => min < currentMinute);
        }
        return [];
      },        
    };     
  };

  
  const onSubmit = (values: any) => {
    setLoading(true);

       console.log('time', disposition1Time)
    const payload = {
      status: getEnumKey("CASE_STATUS", caseStatus),
      comments: values?.comment,
      dispositionAndStagesRequest: {
        disposition1: values?.disposition1,
        dispositionDateTime:(disposition1Date && disposition1Time) ? 
         moment(disposition1Date).format("YYYY-MM-DD") + " " + (disposition1Time) : null,
        disposition2: values?.disposition2,
        currentStage: {
          key: selectedStageDetail?.key,
          name: selectedStageDetail?.name,
          stages: null,
        },
      },
    };
    API_SERVICE.updateCaseStatus(caseId, payload)
      .then(({ data }) => {
        setIsProductFooter(false);
        getLeadById();
        notification.success({ message: data?.message });
      })
      .catch((e: any) => {
        if ((e?.response?.data?.payload?.comments?.length ?? 0) > 0) {
          notification.error({ message: e?.response?.data?.payload?.comments });
        } else {
          notification.error({ message: API_SERVICE?.handleErrors(e) });
        }
      })
      .finally(() => setLoading(false));
  };

  return (
    <Form
      style={{ width: "100%" }}
      layout="vertical"
      size="large"
      form={formComment}
      onFinish={onSubmit}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          gap: "15px",
        }}
      >
        <Form.Item
          name="disposition1"
          label="Select Disposition 1"
          style={{ width: "100%" }}
          rules={[{ required: true, message: "Please select Disposition 1" }]}
        >
          <Select
            placeholder="Select Disposition 1"
            showSearch
            onSelect={onDisposition1Select}
          >
            {dispositionList?.map((item: any, i: number) => (
              <Select.Option value={item?.level1} key={i}>
                {item?.level1}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item
          name="disposition2"
          label="Select Disposition 2"
          style={{ width: "100%" }}
          rules={[{ required: true, message: "Please select Disposition 2" }]}
        >
          <Select placeholder="Select Disposition 2" showSearch>
            {dispositionList2?.map((item: any, i: number) => (
              <Select.Option value={item} key={i}>
                {item}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
      </div>
      {disposition1Selected === "Follow-up" &&
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            gap: "15px",
          }}
        >
        <Form.Item 
          name="dispositionDate"
          label = "Select Date" 
          style={{width:"100%"}}>
            <DatePicker placeholder="Select date"
              format="MMM DD, YYYY"
              disabledDate={disabledDate}
              onChange={(values)=>setDisposition1Date(values)}
            />
          </Form.Item>
          <Form.Item 
            name="dispositionTime"
            label = "Select Time" 
            style={{width:"100%"}}
            rules={
              [
               { required: disposition1Date, message: "Please select a time for the chosen date" } 
              ]
            }>
            <TimePicker 
                placeholder="Select Time" 
                format = "hh:mm A"  
                use12Hours 
                disabled={!disposition1Date}
                disabledTime={disabledTime}
                onChange={(time) => {
                  const now = dayjs();
                  if (!time) return;
                  const selectedHour = time.hour();
                  const selectedMinute = time.minute();
                  const isDisabled =
                  selectedHour < now.hour() ||
                  (selectedHour === now.hour() && selectedMinute < now.minute());
                  if (isDisabled) {
                    formComment.setFieldsValue({dispositionTime: now});
                    setDisposition1Time(now.locale('en').format("HH:mm:ss "));
                  } 
                  else {
                    setDisposition1Time(time.locale('en').format("HH:mm:ss"));
                  }
                }}
              />    
          </Form.Item>
      </div>
      }
    
    <Form.Item name="comment" className="custom-textarea">
        <TextArea
          autoSize={{ minRows: 5, maxRows: 8 }}
          placeholder="Add comment here..."
        />
      </Form.Item>
      <Space>
        <Form.Item>
          <Button
            className="dynamic-btn-default"
            style={{'--borderColor': appColors?.appSecondaryColor ?? "",minWidth: "100px"}as any}
            onClick={() => setIsProductFooter(false)}
          >
            Cancel
          </Button>
        </Form.Item>
        <Form.Item>
          <Button
            className="dynamic-btn-primary"
            type="primary"
            htmlType="submit"
            loading={loading}
            style={{'--btnColor' :appColors?.appPrimaryColor ?? "",minWidth: "100px"}as any}
          >
            Save
          </Button>
        </Form.Item>
      </Space>
    </Form>
  );
};

export default ProductFooter;
